import { createUseStyles } from "react-jss";
import type { VetBoatsTheme } from "../../theme";

/** Form control styles shared by every form. */
export const useFormStyles = createUseStyles((theme: VetBoatsTheme) => ({
  control: {
    width: "100%",
    boxSizing: "border-box",
    padding: "9px 11px",
    font: "inherit",
    color: theme.color.text,
    background: theme.color.surface,
    border: `1px solid ${theme.color.border}`,
    borderRadius: 6,
    "&:focus": {
      outline: `2px solid ${theme.color.primary}33`,
      borderColor: theme.color.primary,
    },
    "&:disabled": {
      background: theme.color.background,
      color: theme.color.muted,
    },
  },
  textarea: { minHeight: 90, resize: "vertical" },
  grid: {
    display: "grid",
    gap: 14,
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
  },
  actions: {
    display: "flex",
    gap: 10,
    flexWrap: "wrap",
    alignItems: "center",
    marginTop: 16,
  },
  checkbox: {
    display: "flex",
    gap: 8,
    alignItems: "flex-start",
    cursor: "pointer",
  },
  /** Vertical stack of form fields. */
  stack: { display: "grid", gap: 14 },
  /** Space above a block that follows a field grid. */
  spaced: { marginTop: 14 },
  /** Input with an inline button beside it. */
  inline: { display: "flex", gap: 6 },
  intro: { marginTop: 0 },
  finePrint: { marginTop: 20, fontSize: 13, color: theme.color.muted },
}));

/** Page-level layout helpers. */
export const useLayoutStyles = createUseStyles({
  sections: { display: "grid", gap: 20 },
  plainList: { listStyle: "none", margin: 0, padding: 0 },
  inlineGroup: { display: "inline-flex", gap: 6, flexWrap: "wrap" },
});
